class CommonSlider extends HTMLElement {
    constructor() {   
		super();
	}
    connectedCallback() {
        this.sliderWrapper = this.querySelector('.common__slideshow');
        if (!this.sliderWrapper) return;
        const resizeObserver = new ResizeObserver(entries => this.init());
        resizeObserver.observe(this.sliderWrapper);
        // console.log("testdd",this.sliderWrapper.dataset)
    }
    init(){
		const slider = new Swiper( this.sliderWrapper, {
            slidesPerView: parseInt(this.sliderWrapper.dataset.slidesdesktop),
			spaceBetween: parseInt(this.sliderWrapper.dataset.desktopSpace),
			freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
			loop: JSON.parse(this.sliderWrapper.dataset.loop),
			speed: parseInt(this.sliderWrapper.dataset.speed),
			freeModeMomentum: JSON.parse(this.sliderWrapper.dataset.freemomentum),
			horizontal: true,
			grabCursor: true,
			parallax: JSON.parse(this.sliderWrapper.dataset.parallax),
			autoplay: {
				enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
				delay: parseInt(this.sliderWrapper.dataset.delay),
                disableOnInteraction: false,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			pagination: {
				el: ".swiper-pagination",
				dynamicBullets: true,
			},
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},
			breakpoints: {
                359: {
					slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
					spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace)
				},
                768: {
					slidesPerView: parseInt(this.sliderWrapper.dataset.slidestab),
					spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace)
				},
                1024: {
					slidesPerView: parseInt(this.sliderWrapper.dataset.slideslaptop),
					spaceBetween: parseInt(this.sliderWrapper.dataset.laptopspace)
				},
				1440: {
					slidesPerView: parseInt(this.sliderWrapper.dataset.slidesdesktop),
					spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace)
				}
			}
		  });
		  return slider;

	}
}
customElements.define('slider-component', CommonSlider);